function AccordionFuncLicense() {
  const accordionItems = document.querySelectorAll('._js-accordion-license-item');

  accordionItems.forEach(item => {
    const accordionTrigger = item.querySelector('._js-accordion-license');
    const accordionBody = item.querySelector('._js-accordion-license-body');

    accordionTrigger.addEventListener('click', function() {
      // Если текущий аккордеон уже открыт, закрываем его
      if (item.classList.contains('_active')) {
        accordionBody.style.maxHeight = '0';
        item.classList.remove('_active');
      } else {
        // Открываем текущий аккордеон
        item.classList.add('_active');
        accordionBody.style.maxHeight = accordionBody.scrollHeight + "px";
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", AccordionFuncLicense);